import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { useEffect, useState } from "react";
import { Box, Button, Input, Textarea } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FormLabel,
  Grid,
  GridItem,
  Text,
  Select as ChakraSelect,
} from "@chakra-ui/react";
import Select from "react-select"; // Importing react-select

import * as yup from "yup";
import { CUIAutoComplete } from "chakra-ui-autocomplete";
import MultiContactModel from "common/components/commonTableModel/MultiContactModel";
import MultiLeadModel from "common/components/commonTableModel/MultiLeadModel";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";

import { LiaMousePointerSolid } from "react-icons/lia";
import { toast } from "react-toastify";
import { getApi, postApi } from "common/services/api";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";
import moment from "moment";
import { hourDateFormatter } from "common/utils/CalcFunctions";
import { MeetingSchema } from "common/schema";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchModuleData } from "common/redux/reducers/dynamicModuleSlice";
import SearchSelect from "common/components/autoComplete/AutoCompleteSelect";

const TaskInformation = (props) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const initialValuesPro = location.state?.initialValuesProp || {};
  const view = location.state?.view;
  const [relatedContacts, setRelatedContacts] = useState([]);

  const initialValues = {
    agenda: "",
    attendes:
      props.leadContect === "contactView" && props.id
        ? [props.id]
        : view === constant.contact
          ? [initialValuesPro?._id]
          : [],
    attendesLead:
      props.leadContect === "leadView" && props.id
        ? [props.id]
        : view === constant.lead
          ? [initialValuesPro?._id]
          : "",
    location: "",
    related:
      props.leadContect === "contactView" || view === constant.contact
        ? "Contact"
        : props.leadContect === "leadView" || view === constant.lead
          ? "Lead"
          : view === constant.accounts
            ? "Account"
            : view === constant.deals
              ? "Deal"
              : "Contact",
    startDate: convertUtcToIst(new Date()),
    endDate: "",
    notes: "",
    createdBy: user?._id,
    attendesAccount:
      props.leadContect === "leadView" && props.id
        ? [props.id]
        : view === constant.accounts
          ? [initialValuesPro?._id]
          : "",
    attendesDeal: view === constant.deals ? [initialValuesPro?._id] : "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MeetingSchema,
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  useEffect(() => {
    setFieldValue("startDate", convertUtcToIst(new Date()));
  }, []);
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async () => {
    try {
      setIsLoading(true);

      const formattedValues = { ...values };

      if (formattedValues?.startDate) {
        formattedValues.startDate = hourDateFormatter(
          formattedValues.startDate
        );
      }
      if (formattedValues?.endDate) {
        formattedValues.endDate = hourDateFormatter(formattedValues.endDate);
      }

      const payload = Object.fromEntries(
        Object.entries(formattedValues).filter(([_, val]) => {
          if (Array.isArray(val)) return val.length > 0;
          return val !== "" && val !== null && val !== undefined;
        })
      );

      const hasAttendees =
        payload.attendes ||
        payload.attendesLead ||
        payload.attendesAccount ||
        payload.attendesDeal;

      if (hasAttendees) {
        const response = await postApi("api/meeting/add", payload);
        if (response.status === 200) {
          formik.resetForm();
          toast.success(crmConstant.meetingSuccess);
          navigate(-1);
        }
      } else {
        toast.error(crmConstant.selectedTO);
      }
    } catch (e) {
      toast.error(constant.somethingWrong);
    } finally {
      setIsLoading(false);
    }
  };
  const contactData = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);
  const dynamicModules = useSelector((state) => state.dynamicModule.modules);
  const [list, setList] = useState({
    contact: contactData,
    lead: leadData,
    account: dynamicModules?.account?.data,
    deal: dynamicModules?.deal?.data,
  });

  useEffect(() => {
    setList((prev) => ({
      ...prev,
      contact: contactData || [],
      lead: leadData || [],
      account: dynamicModules?.account?.data || [],
      deal: dynamicModules?.deal?.data || [],
    }));
  }, [contactData, leadData, dynamicModules]);

  const dispatch = useDispatch()
  async function getContactListData() {
    dispatch(getContactList({ fetchAllData: true }));

  }

  async function getLeadListData() {
    dispatch(getLeadList({ fetchAllData: true }));

  }

  const fetchAllData = () => {
    try {
      let result = [];

      if (values.related === "Contact" && list.contact) {
        result = list.contact.map((item) => ({
          value: item?._id ?? "",
          label: `${item?.contactName ?? "-"}`,
        }));
      } else if (values.related === "Lead" && list.lead) {
        result = list.lead.map((item) => ({
          value: item?._id ?? "",
          label: item.leadName ?? "",
        }));
      } else if (values.related === constant.account && list.account) {
        result = list.account.map((account) => ({
          value: account._id,
          label: account.accountName,
          contacts: account.contact ?? [],
        }));
      } else if (values.related === constant.deal && list.deal) {
        result = list.deal.map((item) => ({
          value: item?._id ?? "",
          label: item.dealName ?? "",
          contacts: item.contact ?? [],
        }));
      }

      setData(result);
    } catch (e) {
      console.error("Error fetching all data:", e);
      toast.error("Something went wrong while processing data");
    }
  };

  const fetchDynamicData = async (id, type) => {
    await dispatch(fetchModuleData({ moduleId: id, fetchAllData: true, type: type }));

  };
  const fetchCustomDataFields = async (type) => {
    const result = await getApi(`api/custom-field/?moduleName=${type}`);
    const singaleData = result?.data?.find((item) => item?.moduleName === type);
    fetchDynamicData(singaleData?._id, type === "Deals" ? "deal" : "account");
  };
  useEffect(() => {
    getContactListData();
    getLeadListData();
    fetchCustomDataFields("Deals");
    fetchCustomDataFields("Accounts");
  }, []);
  useEffect(() => {
    fetchAllData();
  }, [list, values.related]);
  const extractLabels = (selectedItems) => {
    return selectedItems.map((item) => item._id);
  };

  const countriesWithEmailAsLabel = data?.map((item) => ({
    ...item,
    value: item._id,
    label:
      values.related === "Contact"
        ? `${item.firstName} ${item.lastName}`
        : item.leadName,
  }));

  function onChangeHandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);
  }

  const handleTextareaChange = (e, fieldName, setFieldValue) => {
  const input = e.target.value;
  const limitedText = input.slice(0, 1000);
  setFieldValue(fieldName, limitedText);
};

  const handleBackPage = () => {
    navigate(-1);
  };

  // for relatedContact data

  useEffect(() => {
    if (data.length > 0) {
      let selectedId = null;

      if (
        values.related === constant.account &&
        values.attendesAccount?.length > 0
      ) {
        selectedId = values.attendesAccount[0];
      } else if (
        values.related === constant.deal &&
        values.attendesDeal?.length > 0
      ) {
        selectedId = values.attendesDeal[0];
      }

      if (selectedId) {
        const selectedItem = data.find((item) => item.value === selectedId);
        if (selectedItem) {
          const contactIds = selectedItem.contacts || [];
          const uniqueContactIds = [...new Set(contactIds)];

          const matchedContacts = list.contact
            ?.filter((c) => uniqueContactIds.includes(c._id))
            .map((contact) => ({
              value: contact._id,
              label: contact.contactName || "-",
            }));

          setRelatedContacts(matchedContacts || []);
        }
      }
    }
  }, [
    data,
    values.related,
    values.attendesAccount,
    values.attendesDeal,
    list.contact,
  ]);

  return (
    <>
      <Box className="commonPanelBody">
        <MultiContactModel
          data={data}
          isOpen={contactModelOpen}
          onClose={setContactModel}
          fieldName="attendes"
          setFieldValue={setFieldValue}
        />
        {/* Lead Model  */}
        <MultiLeadModel
          data={data}
          isOpen={leadModelOpen}
          onClose={setLeadModel}
          fieldName="attendesLead"
          setFieldValue={setFieldValue}
        />

        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.meetingName}
              <Text color={"red"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.agenda}
              name="agenda"
              placeholder={crmConstant.meetingName}
              fontWeight="500"
              borderColor={errors.agenda && touched.agenda ? "red.300" : null}
            />
            <Text fontSize="sm" mb="10px" color={"red"}>
              {" "}
              {errors.agenda && touched.agenda && errors.agenda}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.dateAndTime}
              <Text color={"red"}>*</Text>
            </FormLabel>
            <Input
              type="datetime-local"
              fontSize="sm"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              value={values.startDate}
              name="startDate"
              fontWeight="500"
              borderColor={
                errors?.startDate && touched?.startDate ? "red.300" : null
              }
            />
            <Text mb="10px" fontSize="sm" color={"red"}>
              {" "}
              {errors.startDate && touched.startDate && errors.startDate}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.location}
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.location}
              name="location"
              placeholder={crmConstant.location}
              fontWeight="500"
              borderColor={
                errors.location && touched.location ? "red.300" : null
              }
            />
            <Text mb="10px" color={"red"} fontSize="sm">
              {" "}
              {errors.location && touched.location && errors.location}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.status}
            </FormLabel>
            <ChakraSelect
              onChange={(e) => setFieldValue("status", e.target.value)}
              value={values.status}
            >
              <option value="Scheduled">{crmConstant.scheduled}</option>
              <option value="Completed">{crmConstant.completed}</option>
              <option value="Cancelled">{crmConstant.cancelled}</option>
            </ChakraSelect>
            <Text mb="10px" color={"red"} fontSize="sm">
              {errors.related && touched.related && errors.related}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.related}
              <Text color={"red"}>*</Text>
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setFieldValue("related", e.target.value);
                setFieldValue("attendes", []);
                setFieldValue("attendesLead", []);
                setRelatedContacts([]);
                setFieldValue("attendesDeal", "");
                setFieldValue("attendesAccount", "");
              }}
              value={values.related}
            >
              {props.leadContect === "contactView" && (
                <option value="Contact">{crmConstant.contact}</option>
              )}
              {props.leadContect === "leadView" && (
                <option value="Lead">{crmConstant.lead}</option>
              )}
              {!props.leadContect && (
                <>
                  <option value="Contact">{crmConstant.contact}</option>
                  <option value="Lead">{crmConstant.lead}</option>
                  <option value={constant.account}>{constant.account}</option>
                  <option value={constant.deal}>{constant.deal}</option>
                </>
              )}
            </ChakraSelect>
            <Text mb="10px" color={"red"} fontSize="sm">
              {errors.related && touched.related && errors.related}
            </Text>
          </GridItem>

          {values.related === "Contact" && (
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {crmConstant.participants} Contact<Text color={"red"}>*</Text>
              </FormLabel>
              {/* <Select
                onChange={(selectedOption) => {
                  setFieldValue(
                    "attendes",
                    selectedOption ? [selectedOption.value] : []
                  );
                }}
                placeholder={crmConstant.assignTo}
                name="attendes"
                options={data?.length > 0 ? data : []}
                className="basic-multi-select"
                classNamePrefix="select"
                value={
                  data?.find((item) => item.value === values.attendes?.[0]) ||
                  "" // Ensure value is a single item
                }
              /> */}

              <SearchSelect
                isMulti={true}

                placeholder={crmConstant.assignTo}
                name="attendes"
                options={data?.length > 0 ? data : []}
                value={data?.filter((opt) => values.attendes?.includes(opt.value)) || []}
                onSelect={({ value: selectedValues }) => {
                  const newValues = Array.isArray(selectedValues)
                    ? selectedValues.map((v) => (typeof v === 'object' ? v.value : v))
                    : [];
                  setFieldValue("attendes", newValues);
                }}
              />
              <Text mb="10px" color={"red"} fontSize="sm">
                {errors.attendes && touched.attendes && errors.attendes}
              </Text>
            </GridItem>
          )}

          {values.related === "Lead" && (
            <GridItem colSpan={{ base: 6 }} className="selectDropBtn">
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {crmConstant.participants} Lead<Text color={"red"}>*</Text>
              </FormLabel>
              {/* <Select
                onChange={(selectedOption) => {
                  // Handle single value selection
                  setFieldValue(
                    "attendesLead",
                    selectedOption ? [selectedOption.value] : []
                  );
                }}
                placeholder={crmConstant.assignTo}
                name="attendesLead"
                options={data?.length > 0 ? data : []}
                className="basic-multi-select"
                classNamePrefix="select"
                value={
                  data?.find(
                    (item) => item.value === values.attendesLead?.[0]
                  ) || "" // Ensure value is a single item
                }
              /> */}

              <SearchSelect
                name="attendesLead"
                placeholder={crmConstant.assignTo}
                options={data?.length > 0 ? data : []}
                value={
                  data?.find((item) => item.value === values.attendesLead?.[0]) || null
                }
                onSelect={({ value }) => {
                  setFieldValue(
                    "attendesLead",
                    value ? [value] : []
                  );
                }}
              />
              <Text mb="10px" color={"red"} fontSize="sm">
                {errors.attendesLead &&
                  touched.attendesLead &&
                  errors.attendesLead}
              </Text>
            </GridItem>
          )}

          {(values.related === constant.account ||
            values.related === constant.deal) && (
              <GridItem colSpan={{ base: 6 }} className="selectDropBtn">
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.participants}{" "}
                  {values.related === constant.account
                    ? constant.account
                    : constant.deal}
                  <Text color="red">*</Text>
                </FormLabel>

                {/* <Select
                  isMulti={false}
                  onChange={(selectedOption) => {
                    const selectedValue = selectedOption?.value || "";

                    if (values.related === constant.account) {
                      setFieldValue(
                        "attendesAccount",
                        selectedValue ? [selectedValue] : []
                      );
                    } else if (values.related === constant.deal) {
                      setFieldValue(
                        "attendesDeal",
                        selectedValue ? [selectedValue] : []
                      );
                    }

                    const selectedItem = data.find(
                      (item) => item.value === selectedValue
                    );
                    const contactIds = selectedItem?.contacts || [];
                    const uniqueContactIds = [...new Set(contactIds)];

                    const matchedContacts = list.contact
                      ?.filter((c) => uniqueContactIds.includes(c._id))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }));

                    setRelatedContacts(matchedContacts || []);
                  }}
                  name={
                    values.related === constant.account
                      ? "attendesAccount"
                      : "attendesDeal"
                  }
                  options={data || []}
                  className="basic-single-select"
                  classNamePrefix="select"
                  placeholder={crmConstant.assignTo}
                  value={
                    data.find(
                      (item) =>
                        item.value ===
                        (values.related === constant.account
                          ? values.attendesAccount?.[0]
                          : values.attendesDeal?.[0])
                    ) || null
                  }
                /> */}

                <SearchSelect
                  isMulti={false}
                  name={
                    values.related === constant.account
                      ? "attendesAccount"
                      : "attendesDeal"
                  }
                  options={data || []}
                  placeholder={crmConstant.assignTo}
                  value={
                    data.find(
                      (item) =>
                        item.value ===
                        (values.related === constant.account
                          ? values.attendesAccount?.[0]
                          : values.attendesDeal?.[0])
                    ) || null
                  }
                  onSelect={({ value: selectedValue }) => {
                    const selected = selectedValue || "";

                    // Update the right field
                    if (values.related === constant.account) {
                      setFieldValue(
                        "attendesAccount",
                        selected ? [selected] : []
                      );
                    } else if (values.related === constant.deal) {
                      setFieldValue(
                        "attendesDeal",
                        selected ? [selected] : []
                      );
                    }

                    // Find contacts for the selected item
                    const selectedItem = data.find(
                      (item) => item.value === selected
                    );
                    const contactIds = selectedItem?.contacts || [];
                    const uniqueContactIds = [...new Set(contactIds)];

                    const matchedContacts = list.contact
                      ?.filter((c) => uniqueContactIds.includes(c._id))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }));

                    setRelatedContacts(matchedContacts || []);
                  }}
                />


                <Text mb="10px" color="red" fontSize="sm">
                  {(values.related === constant.account &&
                    errors.attendesAccount &&
                    touched.attendesAccount &&
                    errors.attendesAccount) ||
                    (values.related === constant.deal &&
                      errors.attendesDeal &&
                      touched.attendesDeal &&
                      errors.attendesDeal)}
                </Text>
              </GridItem>
            )}

          {relatedContacts.length > 0 && (
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel fontSize="sm" fontWeight="500" mb="8px">
                {constant.selectContacts} {values.related}
              </FormLabel>
              {/* <Select
                isMulti
                placeholder="Select related contacts"
                name="attendesContact"
                options={relatedContacts}
                onChange={(selected) => {
                  const selectedContactIds = selected.map((item) => item.value);
                  setFieldValue("attendes", selectedContactIds);
                }}
                value={relatedContacts.filter((item) =>
                  values.attendes?.includes(item.value)
                )}
                className="basic-multi-select"
                classNamePrefix="select"
              /> */}

              <SearchSelect
                isMulti
                placeholder="Select related contacts"
                name="attendesContact"
                options={relatedContacts}
                value={values.attendes}
                onSelect={({ value: selectedValues }) => {
                  setFieldValue("attendes", selectedValues || []);
                }}
              />

              <Text mb="10px" color={"red"} fontSize="sm">
                {errors.attendes && touched.attendes && errors.attendes}
              </Text>
            </GridItem>
          )}

          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.description}
            </FormLabel>
            <Textarea
              resize={"none"}
              fontSize="sm"
              placeholder={crmConstant.description}
              onChange={(e) => handleTextareaChange(e, "notes", setFieldValue)}
              onBlur={handleBlur}
              value={values.notes}
              name="notes"
              fontWeight="500"
              borderColor={errors.notes && touched.notes ? "red.300" : null}
            />
            <Text
  mt={1}
  fontSize="xs"
  textAlign="right"
  color={(values.notes?.length || 0) === 1000 ? "red.500" : "gray.500"}
>
  {0 + (values.notes?.length || 0)}/1000
</Text>
            <Text mb="10px" color={"red"} fontSize="sm">
              {" "}
              {errors.notes && touched.notes && errors.notes}
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button className="nextBtn" variant="primary" onClick={handleSubmit}>
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.save}
        </Button>
      </Box>
    </>
  );
};

const CreateMeeting = () => {
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate(-1);
  };

  const tabsData = [
    { label: crmConstant.meetingInformation, Icon: JobOpeningIcon },
  ];

  const panelsData = [<TaskInformation />];

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createMeeting}
    />
  );
};

export default CreateMeeting;
